import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Table } from "antd";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
import { useRuleGroupColumns, useRuleGroupDisplayColumns } from "./rule-group/columns.js";
import { RuleGroupTable } from "./rule-group/rule-group-table.js";
function FormFieldContentBlockerTemplateRuleGroups() {
    const { t } = useTranslation();
    const ruleGroupColumns = useRuleGroupColumns(t);
    const displayColumnDefinition = useRuleGroupDisplayColumns(t);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.RuleGroups,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ContentBlockerField.RuleGroups, t),
            extra: t("By default, at least one rule from one group must be resolved to suggest the content blocker (or connected service) in the scanner."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ContentBlockerField.RuleGroups,
                    disableStrategies: getDisableStrategies(true),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Table, {
                        rowKey: "id",
                        pagination: false,
                        dataSource: extended[ContentBlockerField.RuleGroups],
                        columns: displayColumnDefinition
                    }),
                    children: /*#__PURE__*/ _jsx(RuleGroupTable, {
                        formName: ContentBlockerField.RuleGroups,
                        columns: ruleGroupColumns
                    })
                });
            }
        })
    });
}
export { FormFieldContentBlockerTemplateRuleGroups };
